<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview :title="titleName">
          <template v-slot:preview>
            <b-form ref="form" lazy-validation class="row">
              <!-- Input session -->
              <b-container class="bv-example-row">
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <span>
                        <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file
                        excel đúng format, hoặc có thể tải ở
                        <a
                          class="cursor-pointer"
                          @click="onClickDownloadTemplate"
                          >đây</a
                        >
                      </span>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <span> <b>Bước 2:</b> Tiến hành Import </span>
                    <div style="padding-top: 15px">
                      <b-form-file
                        @change="selectFile"
                        v-model="selectedFile"
                        ref="file-input"
                        style="display: none"
                        id="file-input"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      ></b-form-file>
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-button
                            :disabled="isProcessing"
                            variant="secondary"
                            @click="openFile('file-input')"
                            v-b-tooltip.hover
                            title="Chọn file"
                            ><i class="fas fa-paperclip"></i
                          ></b-button>
                        </b-input-group-prepend>

                        <b-form-input
                          type="text"
                          :disabled="isProcessing"
                          v-model="fileName"
                          placeholder="Hãy chọn một tệp tin"
                          @click="openFile('file-input')"
                          v-on:keydown.prevent
                          style="caret-color: transparent; cursor: pointer"
                          autocomplete="off"
                          readonly
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            variant="secondary"
                            :disabled="!selectedFile || isProcessing"
                            v-b-tooltip.hover
                            @click="uploadFile"
                            title="Tải file"
                            ref="up_excel"
                          >
                            <i class="fas fa-upload text-primary"></i>
                          </b-button>
                          <b-button
                            variant="secondary"
                            :disabled="!selectedFile || isProcessing"
                            @click="resetFileSelection"
                            v-b-tooltip.hover
                            title="Xóa file"
                            ><i class="fas fa-trash text-danger"></i
                          ></b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <label class="description" style="font-size: 10px">
                        Chỉ nhận file csv, xls, xlsx và nhỏ hơn 5MB</label
                      >
                    </div>
                  </b-col>
                </b-row>
              </b-container>
              <!-- End input session -->
              <b-container>
                <template v-if="errorsHeader.length" cols="3">
                  <ul
                    v-for="(item, index) in errorsHeader"
                    :key="index"
                    class="text-danger ml-4"
                  >
                    <li>{{ item.error }}</li>
                  </ul>
                </template>
                <template v-if="errorValid.length || errorInValid.length">
                  <ul class="list-inline d-flex">
                    <li
                      @click="onFilterItem('valid')"
                      style="cursor: pointer"
                      class="mr-2"
                    >
                      <b
                        >Hợp lệ:
                        <span class="text-success">{{
                          convertPrice(errorValid.length)
                        }}</span></b
                      >
                    </li>
                    <li
                      @click="onFilterItem('invalid')"
                      style="cursor: pointer"
                      class="mr-2"
                    >
                      <b
                        >Không hợp lệ:
                        <span class="text-danger">{{
                          convertPrice(errorInValid.length)
                        }}</span></b
                      >
                    </li>
                  </ul>
                </template>
              </b-container>

              <b-container class="mt-3" v-show="importItems.length > 0">
                <hr
                  class="hr-text"
                  data-content="Danh sách Lead"
                  style="font-weight: 600"
                />
                <b-table
                  class="myTable"
                  responsive
                  bordered
                  hover
                  :fields="fields"
                  :items="importItems"
                  id="my-table"
                  :per-page="10"
                  :current-page="currentPage"
                >
                  <template v-slot:cell(fullName)="row">
                    <b>{{ row.item.fullName }}</b>
                    <p>{{ row.item.phoneNumber }}</p>
                  </template>
                  <template v-slot:cell(title)="row">
                    <span>{{ getTitleName(row.item.title) }}</span>
                  </template>
                  <template v-slot:cell(gender)="row">
                    <span>{{ getGenderName(row.item.gender) }}</span>
                  </template>

                  <!-- SourcesCell -->
                  <template v-slot:cell(source)="row">
                    <span>{{ getSourceName(row.item.source) }}</span>
                  </template>

                  <template v-slot:cell(status)="row">
                    <div class="text-center">
                      <span
                        v-text="getStatusName(row.item.status)"
                        class="label font-weight-bold label-lg label-inline"
                        v-bind:class="getStatusClass(row.item.status)"
                        style="width: max-content"
                      ></span>
                    </div>
                  </template>
                  <template #cell(errors)="{ item }">
                    <span v-if="item.errors && item.errors.length">
                      <i
                        :title="htmlGetTitleErrors(item.errors)"
                        class="fas fa-exclamation-circle text-danger ml-1"
                        v-b-tooltip.hover.html
                      ></i>
                    </span>
                    <span v-else>
                      <i class="fas fa-check-circle text-success ml-1"></i>
                    </span>
                  </template>
                </b-table>
                <b-col class="row mt-3">
                  <b>
                    Tổng số bản ghi:
                    {{ importItems ? importItems.length : 0 }}
                  </b>
                </b-col>
                <b-pagination
                  v-show="importItems.length > 10"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="10"
                  aria-controls="my-table"
                  align="right"
                ></b-pagination>
              </b-container>
            </b-form>
          </template>
          <template v-slot:foot>
            <div class="bv-example-row container">
              <b-row>
                <b-button
                  style="font-weight: 600; width: 70px"
                  variant="primary"
                  size="sm"
                  type="submit"
                  @click="create"
                  v-show="checkPropUpdate()"
                  class="mr-2"
                  ><b>Lưu</b></b-button
                >
                <b-button
                  style="font-weight: 600; width: 70px"
                  variant="secondary"
                  size="sm"
                  @click="$router.go(-1)"
                  >Hủy</b-button
                >
              </b-row>
            </div>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<style scoped>
.myTable /deep/ .table {
  color: #464e5f;
  background-color: transparent;
}
.label {
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
}
/* Sources cell styling */
.sources-list {
  display: flex;
  flex-direction: column;
}

.source-item {
  padding: 2px 0;
  text-align: center;
  margin-bottom: 4px;
  border-bottom: 1px solid #f0f0f0;
}

.source-item:last-child {
  margin-bottom: 0;
  border-bottom: none;
}
</style>

<script>
import axios from 'axios';
import xlsx from 'xlsx';
import { cloneDeep } from 'lodash';

import * as ENUM_NAME from '@/utils/enum-name';
import * as ENUM from '@/utils/enum';

import fileDownload from '@/utils/file-download';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';

import KTCodePreview from '@/view/content/CodePreview.vue';
import LeadService from '@/core/api/lead/lead.service';
import { permissionMixin } from '@/view/mixins/permission.mixins';

import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';

// Constants
const SPINNER_CLASSES = [
  'spinner',
  'spinner-primary',
  'spinner-md',
  'spinner-center',
  'px-7',
];

const thStyleCommon = {
  textAlign: 'center',
  fontWeight: 600,
  color: '#181c32',
  verticalAlign: 'middle',
};

export default {
  mixins: [permissionMixin],
  data() {
    return {
      // Contants
      PERMISSIONS: ENUM.PERMISSIONS,

      // Loading states
      isUploading: false,
      isSubmitting: false,

      // File handling
      selectedFile: null,
      fileName: '',

      // Data states
      rawData: [],
      validatedData: [],

      fields: [
        {
          key: 'fullName',
          label: 'Tên khách hàng',
          thStyle: thStyleCommon,
          tdClass: 'text-left',
        },
        {
          key: 'title',
          label: 'Danh xưng',
          thStyle: thStyleCommon,
          tdClass: 'text-center',
        },
        {
          key: 'gender',
          label: 'Giới tính',
          thStyle: thStyleCommon,
          tdClass: 'text-center',
        },
        {
          key: 'email',
          label: 'Email',
          thStyle: thStyleCommon,
          tdClass: 'text-left',
        },
        {
          key: 'address',
          label: 'Địa chỉ',
          thStyle: thStyleCommon,
          tdClass: 'text-left',
        },
        {
          key: 'source',
          label: 'Nguồn',
          thStyle: thStyleCommon,
          tdClass: 'text-center',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          thStyle: thStyleCommon,
          tdClass: 'text-center',
        },
        {
          key: 'errors',
          label: 'Kiểm tra',
          thStyle: thStyleCommon,
          tdClass: 'text-center',
        },
      ],
      importItems: [],
      currentPage: 1,
      titleName: 'Nhập excel Lead',
      errorsHeader: [],
    };
  },
  created() {
    const hasPermission = this.hasPermission(ENUM.PERMISSIONS.LEAD_IMPORT);
    if (!hasPermission) {
      this.$router.push({ name: 'dashboard' });
    }
  },
  components: {
    KTCodePreview,
  },
  computed: {
    rows() {
      return this.importItems.length;
    },
    errorValid() {
      return this.validatedData.filter(
        (current) => !current.errors || !current.errors.length,
      );
    },
    errorInValid() {
      return this.validatedData.filter(
        (current) => current.errors && current.errors.length,
      );
    },
    isProcessing() {
      return this.isUploading || this.isSubmitting;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Leads', route: '/crm/leads' },
      { title: this.titleName },
    ]);
  },
  methods: {
    convertPrice: function (number) {
      return new Intl.NumberFormat('vn-VN').format(number);
    },
    async onClickDownloadTemplate() {
      try {
        const response = await axios.get('leads/template-import', {
          responseType: 'blob',
        });
        const fileName =
          fileDownload.getFileName(response) || 'Lead_Template.xlsx';
        fileDownload.createFile(response.data, fileName);
        makeToastSuccess('Tải template thành công!');
      } catch (error) {
        console.error('Error downloading template:', error);
        makeToastFaile('Lỗi khi tải template!');
      }
    },
    async create() {
      if (this.isSubmitting) return;

      this.isSubmitting = true;
      this.errorsHeader = [];

      const validItems = this.errorValid;

      if (!validItems.length) {
        makeToastFaile('Không có dữ liệu hợp lệ để import');
        this.isSubmitting = false;
        return;
      }

      try {
        const { data } = await LeadService.bulkCreate(validItems);
        const { status, message } = data.data;

        if (status) {
          makeToastSuccess(message || 'Import Lead thành công');
          this.resetComponent();
          this.$router.push({ name: 'list-leads' });
        } else {
          makeToastFaile(message || 'Import Lead thất bại');
        }
      } catch (error) {
        console.error('Error importing leads:', error);
        makeToastFaile(
          error.response?.data?.message || 'Có lỗi xảy ra khi import Lead',
        );
      } finally {
        this.isSubmitting = false;
      }
    },
    async uploadFile() {
      if (this.isUploading) {
        makeToastFaile('File đang được xử lý...');
        return;
      }

      if (!this.selectedFile) {
        makeToastFaile('Vui lòng chọn file Excel');
        return;
      }

      this.isUploading = true;
      this.setLoadingState(true);

      try {
        const rows = await this.readExcelFile(this.selectedFile);
        const processedData = this.generateListFromDataExcel(rows);
        await this.submitDataToBackend(processedData);
      } catch (error) {
        console.error('Error processing file:', error);
        makeToastFaile('Có lỗi xảy ra khi xử lý file');
      } finally {
        this.isUploading = false;
        this.setLoadingState(false);
      }
    },

    readExcelFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          try {
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const rows = xlsx.utils.sheet_to_json(sheet, { header: 1 });
            resolve(rows);
          } catch (error) {
            reject(error);
          }
        };

        reader.onerror = () => reject(new Error('Không thể đọc file'));
        reader.readAsBinaryString(file);
      });
    },

    setLoadingState(isLoading) {
      const submitButton = this.$refs['up_excel'];
      if (!submitButton) return;

      if (isLoading) {
        submitButton.innerHTML = '';
        submitButton.classList.add(...SPINNER_CLASSES);
      } else {
        submitButton.innerHTML = '<i class="fas fa-upload text-primary"></i>';
        submitButton.classList.remove(...SPINNER_CLASSES);
      }
    },

    async submitDataToBackend(rows) {
      const validRows = rows.filter(
        (item) => item && Object.keys(item).length > 0,
      );

      if (!validRows.length) {
        makeToastFaile('Không có dữ liệu hợp lệ trong file');
        return;
      }

      try {
        const response = await LeadService.importExcel(validRows);

        const {
          valid,
          message,
          errorCode,
          rows: resultRows,
          errors,
        } = response.data.data;

        if (valid) {
          this.importItems = resultRows;
          this.validatedData = cloneDeep(resultRows);
          makeToastSuccess(message || 'Xử lý dữ liệu thành công');
        } else {
          this.handleValidationErrors(errorCode, errors, resultRows, message);
        }
      } catch (error) {
        console.error('Error submitting data:', error);
        const errorMessage =
          error.response?.data?.message ||
          'Có lỗi xảy ra khi xử lý dữ liệu. Vui lòng thử lại.';
        makeToastFaile(errorMessage);
      }
    },

    handleValidationErrors(errorCode, errors, rows, message) {
      switch (errorCode) {
        case 'header_error':
          this.errorsHeader = errors;

          break;
        case 'data_error':
          this.importItems = rows;
          this.validatedData = cloneDeep(rows);
          break;
        default:
          this.errorsHeader = errors || [];
      }
      makeToastFaile(message || 'Import Lead thất bại');
    },

    generateListFromDataExcel(rows) {
      if (!rows || rows.length < 2) {
        return [];
      }

      const headerMap = new Map([
        ['Danh xưng', 'title'],
        ['Tên khách hàng', 'fullName'],
        ['Email', 'email'],
        ['Giới tính', 'gender'],
        ['Số điện thoại', 'phoneNumber'],
        ['CCCD', 'citizenId'],
        ['Ngày cấp CCCD', 'citizenIdIssuedDate'],
        ['Tên công ty', 'companyName'],
        ['Mã số thuế', 'taxCode'],
        ['Địa chỉ', 'address'],
        ['Nguồn khách hàng', 'source'],
        ['ID App Dcore', 'appDcoreId'],
        ['Tình trạng', 'status'],
        ['Đánh giá', 'evaluation'],
        ['Nhóm khách hàng', 'customerGroup'],
        ['Ngày sinh', 'birthDate'],
        ['Ngày chuyển đổi', 'conversionDate'],
        ['Mã sản phẩm quan tâm', 'interestedProductCodes'],
        ['Người được giao', 'assignedUserId'],
        ['Mô tả đánh giá', 'evaluationDescription'],
        ['Chiến dịch', 'campaign'],
      ]);

      const [headers, ...dataRows] = rows;

      // Pre-compute header mapping to avoid repeated lookups
      const headerIndexMap = new Map();
      headers.forEach((header, index) => {
        const mappedKey = headerMap.get(header);
        if (mappedKey) {
          headerIndexMap.set(index, mappedKey);
        }
      });

      // Filter out empty rows early
      const validRows = dataRows.filter(
        (row) => row && row.some((cell) => Boolean(cell)),
      );

      return validRows.map((row) => {
        const obj = {};
        headerIndexMap.forEach((mappedKey, index) => {
          const value = row[index];
          obj[mappedKey] = this.sanitizeValue(value);
        });
        return obj;
      });
    },

    sanitizeValue(value) {
      if (typeof value === 'string') {
        return value.toString().trim();
      }
      return value;
    },

    resetFileSelection() {
      this.selectedFile = null;
      this.fileName = '';
      this.resetData();
      if (this.$refs['file-input']) {
        this.$refs['file-input'].reset();
      }
    },

    resetData() {
      this.importItems = [];
      this.validatedData = [];
      this.rawData = [];
      this.errorsHeader = [];
    },

    resetComponent() {
      this.resetFileSelection();
      this.resetData();
      this.currentPage = 1;
    },

    selectFile(event) {
      const files = event.target.files[0];

      if (!files) {
        this.selectedFile = null;
        this.fileName = '';
        return;
      }
      if (!/(xls|xlsx|csv)$/.test(this.getExtension(files.name))) {
        this.clearFiles();
        return makeToastFaile(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls .xlsx hoặc csv',
        );
      } else if (files.size > 5 * 1024 * 1024) {
        this.clearFiles();
        return makeToastFaile('Chọn file nhỏ hơn 5MB');
      }

      this.importItems = [];
      this.validatedData = [];
      this.errorsHeader = [];
      this.selectedFile = files;
      this.fileName = files.name;
    },
    clearFiles() {
      this.selectedFile = null;
      this.fileName = '';
      this.$refs['file-input'].reset();
    },
    openFile(name) {
      document.getElementById(name).click();
    },
    getExtension(fname) {
      const pos = fname.lastIndexOf('.');
      const strlen = fname.length;
      let extension = '';
      if (pos != -1 && strlen != pos + 1) {
        let ext = fname.split('.');
        let len = ext.length;
        extension = ext[len - 1].toLowerCase();
      } else {
        return makeToastFaile('File không đúng định dạng');
      }
      return extension;
    },
    onFilterItem(type) {
      switch (type) {
        case 'valid': {
          this.importItems = this.validatedData.filter(
            (current) => !current.errors || !current.errors.length,
          );
          break;
        }
        case 'invalid': {
          this.importItems = this.validatedData.filter(
            (current) => current.errors && current.errors.length,
          );
          break;
        }
        default: {
          this.importItems = this.validatedData;
          break;
        }
      }
    },
    checkPropUpdate() {
      if (this.errorInValid.length > 0) {
        return false;
      }
      if (!this.importItems.length || !this.errorValid.length) {
        return false;
      }
      return true;
    },

    htmlGetTitleErrors(errors) {
      return errors.reduce((result, itemError) => {
        return (result += `<span class='text-danger d-block text-left'>" ${itemError.error}</span>`);
      }, '');
    },
    getTitleName(title) {
      return ENUM_NAME.LEAD_TITLE_NAME[title] || 'Không xác định';
    },
    getGenderName(gender) {
      return ENUM_NAME.GENDER_NAME[gender] || 'Không xác định';
    },
    getStatusName(status) {
      return ENUM_NAME.LEAD_STATUS_NAME[status] || status || 'Chưa xác định';
    },
    getStatusClass(status) {
      const statusMap = {
        [ENUM.LEAD_STATUS.INTERESTED]: 'label-light-primary',
        [ENUM.LEAD_STATUS.NOT_INTERESTED]: 'label-light-danger',
        [ENUM.LEAD_STATUS.POTENTIAL]: 'label-light-warning',
        [ENUM.LEAD_STATUS.PURCHASED]: 'label-light-success',
      };
      return statusMap[status] || 'label-light-danger';
    },
    getSourceName(source) {
      return ENUM_NAME.LEAD_SOURCE_NAME[source] || 'Không xác định';
    },
  },
};
</script>
